<template>
    <div class="marketplace-recommend-section">
        <v-container>
            <div class="d-flex justify-space-between align-center mb-6">
                <h2 class="section-title">สินค้าแนะนำ</h2>
                <v-btn v-if="hasMore" color="#198C19" light rounded small elevation="0" class="px-4 view-more-btn"
                    outlined :to="{ name: 'all_products' }">
                    ดูเพิ่มเติม
                </v-btn>
            </div>

            <v-row>
                <v-col v-for="product in displayedProducts" :key="product.id" cols="6" sm="6" md="3" lg="3">
                    <ProductCard :product="product" />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { getProductRecommendationsApi } from "@/services/api/product";
import ProductCard from "@/components/Shared/ProductCard.vue";

const DISPLAY_LIMIT = 8;
const FETCH_LIMIT = 9; // fetch 9 → if we get >8 we know there are more

export default {
    name: "MarketplaceRecommend",
    components: {
        ProductCard
    },
    data() {
        return {
            products: [],
            isLoading: false
        };
    },
    computed: {
        displayedProducts() {
            return this.products.slice(0, DISPLAY_LIMIT);
        },
        hasMore() {
            return this.products.length > 8;
        }
    },
    async mounted() {
        await this.fetchRecommendations();
    },
    methods: {
        async fetchRecommendations() {
            this.isLoading = true;
            try {
                const response = await getProductRecommendationsApi(FETCH_LIMIT);
                if (response && response.success && response.data) {
                    this.products = response.data || [];
                } else {
                    this.products = [];
                }
            } catch (error) {
                console.error("Error fetching recommendations:", error);
                this.products = [];
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>

<style scoped>
.marketplace-recommend-section {
    padding: 40px 0;
    max-width: 1440px;
    margin: 0 auto;
}

.section-title {
    font-size: 24px;
    font-weight: 700;
    color: #198C19;
}

.view-more-btn {
    border-color: #198C19;
    color: #198C19;
}

@media (max-width: 600px) {
    .marketplace-recommend-section {
        padding: 24px 0;
    }

    .section-title {
        font-size: 18px;
    }
}
</style>
